import { useContext } from "react";
import useSWR from "swr";

import getBuyerAPIDomain from "../getBuyerAPIDomain";
import getSearchResults from "../vehicle-search-details/getSearchResults";
import { ErrorContext } from "../context/ErrorContext";
import { VehicleSearchResults } from "../vehicle-search-details/vehicleSearch.type";
import { useAuth } from "@bca-auth0/bca-auth0-provider";
import { useSelector } from "react-redux";
import { GET_STATE } from "../redux/slices/appSlice";
import { StoreType } from "../StoreType";

export const useGetSearchResults = (allQueryStrings) => {
  const errorContext = useContext(ErrorContext);

  const {
    app: { isToUseAuthZero },
  }: StoreType = useSelector(GET_STATE);
  const { accessToken } = useAuth(!isToUseAuthZero);

  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);

  const getSearchResultsUrl = buyerAPIDomain
    ? new URL(`${buyerAPIDomain.href}/search`, buyerAPIDomain)
    : null;

  if (getSearchResultsUrl && allQueryStrings) {
    Object.keys(allQueryStrings).map((queryName) =>
      getSearchResultsUrl.searchParams.append(
        queryName,
        allQueryStrings[queryName] as string
      )
    );
  }

  const { data: searchResults, mutate: mutateSearch } =
    useSWR<VehicleSearchResults>(
      accessToken || !isToUseAuthZero
        ? [getSearchResultsUrl.href, accessToken, isToUseAuthZero]
        : null,
      getSearchResults,
      {
        revalidateOnFocus: false,
        shouldRetryOnError: false,
        onSuccess: () => {
          errorContext?.dispatch({ type: "clear" });
          if (searchResults?.degradedServices?.length > 0) {
            errorContext?.dispatch({
              type: "tracking",
            });
          }
        },
        onError: () => {
          errorContext?.dispatch({ type: "search" });
        },
      }
    );

  return {
    searchResults,
    mutateSearch,
  };
};
